module.exports = __webpack_public_path__ + "img/Logo_Fiat_Chrysler_Automobiles.65fefd97.png";